<template>
  <app-chip class="bg-gray-50 text-black" :icon="icon" :size="size">
    {{ type }}
  </app-chip>
</template>

<script lang="ts" setup>
import { toBlogPostResourceIcon } from "~/business-areas/blog/blog.model";

const properties = defineProps<{
  type?: string;
  size?: "small";
}>();

const icon = computed(() => toBlogPostResourceIcon(properties.type));
</script>
